export default __webpack_public_path__ + "static/media/moon.dd347a47.jpg";